/**
 * Contextual Navigation - Active State
 * Adds 'active' class to navigation items when on matching pages
 */
(function() {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', activateCurrentNav);
  } else {
    activateCurrentNav();
  }

  function activateCurrentNav() {
    const currentPath = window.location.pathname;
    const menuItems = document.querySelectorAll('.header__menu > ul > li');
    
    menuItems.forEach(li => {
      let isActive = false;
      
      // Get the main link - use :scope to ensure it's a direct child
      const mainLink = li.querySelector(':scope > a[href], :scope > details > summary[data-link]');
      if (!mainLink) return;
      
      const mainUrl = mainLink.getAttribute('href') || mainLink.getAttribute('data-link');
      if (!mainUrl) return;
      
      // Parse the main URL to get just the path
      const mainPath = new URL(mainUrl, window.location.origin).pathname;
      
      // Check exact match with main link
      if (currentPath === mainPath) {
        isActive = true;
      } else {
        // Get ONLY navigation links within THIS menu item's dropdown
        // Using :scope to ensure we only look within this specific li
        const megaMenuList = li.querySelector(':scope > details .mega-menu__list');
        const dropdownNav = li.querySelector(':scope > details .dropdown__nav');
        
        let allLinks = [];
        
        if (megaMenuList) {
          allLinks = [...megaMenuList.querySelectorAll('a[href]')];
        }
        
        if (dropdownNav) {
          allLinks = [...allLinks, ...dropdownNav.querySelectorAll('a[href]')];
        }
        
        // Check child links if they exist
        if (allLinks.length > 0) {
          for (const link of allLinks) {
            const linkPath = new URL(link.href, window.location.origin).pathname;
            
            // Check if current path matches exactly
            if (currentPath === linkPath) {
              isActive = true;
              break;
            }
            
            // Check if current path starts with this link's path
            if (currentPath.startsWith(linkPath)) {
              // Make sure it's a real path match, not just a prefix
              // Next char must be / (subpath) or ? (query param)
              const nextChar = currentPath.charAt(linkPath.length);
              if (nextChar === '/' || nextChar === '?') {
                isActive = true;
                break;
              }
            }
          }
        } else {
          // No child links - this is a simple menu item
          // Check if current path starts with the main link path
          // This handles cases like /blogs/the-endota-edit -> /blogs/the-endota-edit/post-slug
          if (currentPath.startsWith(mainPath)) {
            const nextChar = currentPath.charAt(mainPath.length);
            if (nextChar === '/' || nextChar === '?') {
              isActive = true;
            }
          }
        }
      }
      
      // Apply active class to span.menu__item
      if (isActive) {
        li.classList.add('active');
        
        // Find and activate the span.menu__item element
        const menuItemSpan = li.querySelector('.menu__item');
        if (menuItemSpan) {
          menuItemSpan.classList.add('active');
        }
      }
    });
  }
})();